import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { KROS_DESIGN_VERSION, NEW_DESIGN } from '@kros-sk/core/design-version';
import { ToastService } from '@kros-sk/ui/toast';

const V4_DESIGN = 4;

@Component({
  selector: 'kros-lost-network-connection-toast',
  templateUrl: './lost-network-connection-toast.component.html',
  styleUrl: './lost-network-connection-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'toast-body-component' },
})
export class LostNetworkConnectionToastComponent {
  protected newDesign = inject(NEW_DESIGN, { optional: true });
  protected isV4Design = (inject(KROS_DESIGN_VERSION, { optional: true }) ?? 0) >= V4_DESIGN;
  readonly #toastService = inject(ToastService);

  toast = input.required();

  removeToast(toast: any): void {
    this.#toastService.remove(toast);
  }

  protected reload(): void {
    window.location.reload();
  }
}
